import React from "react";
import { Box, Flex, Link, Text } from "@chakra-ui/react";
import { FaApple, FaGooglePlay } from "react-icons/fa";

export const APP_LINKS = {
  ios: "https://apps.apple.com/in/app/31gauge/id6757912501",
  android: "https://play.google.com/store/apps/details?id=com.vetkai.gauge31&hl=en_IN",
};

const stores = [
  {
    name: "App Store",
    eyebrow: "Download on the",
    href: APP_LINKS.ios,
    icon: FaApple,
    platform: "ios",
  },
  {
    name: "Google Play",
    eyebrow: "Get it on",
    href: APP_LINKS.android,
    icon: FaGooglePlay,
    platform: "android",
  },
];

export const AppStoreLinks = ({
  align = "center",
  compact = false,
  location = "download-section",
}) => (
  <Flex
    direction={{ base: "column", sm: "row" }}
    align={align}
    justify={align === "center" ? "center" : "flex-start"}
    gap={compact ? 3 : 4}
    w={{ base: "100%", sm: "auto" }}
  >
    {stores.map(({ name, eyebrow, href, icon: StoreIcon, platform }) => (
      <Link
        key={platform}
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={`Download 31Gauge on the ${name}`}
        data-store={platform}
        data-location={location}
        w={{ base: "100%", sm: compact ? "170px" : "190px" }}
        maxW={{ base: "320px", sm: "none" }}
        _hover={{ textDecoration: "none" }}
        _focusVisible={{
          outline: "3px solid #0095C8",
          outlineOffset: "3px",
          borderRadius: "10px",
        }}
      >
        <Flex
          minH={compact ? "54px" : "60px"}
          px={compact ? 4 : 5}
          py={2}
          align="center"
          gap={3}
          bg="#111827"
          color="white"
          border="1px solid rgba(255,255,255,0.28)"
          borderRadius="10px"
          boxShadow="0 6px 20px rgba(0,0,0,0.18)"
          transition="all 0.25s cubic-bezier(0.4,0,0.2,1)"
          _hover={{
            transform: "translateY(-2px)",
            borderColor: "rgba(0,149,200,0.75)",
            boxShadow: "0 10px 28px rgba(0,149,200,0.25)",
          }}
          _active={{ transform: "translateY(0)" }}
        >
          <Box as={StoreIcon} aria-hidden="true" fontSize={compact ? "25px" : "29px"} flexShrink={0} />
          <Box textAlign="left" overflow="visible">
            <Text
              fontFamily="'Inter', sans-serif"
              fontSize="0.65rem"
              lineHeight="1.1"
              color="rgba(255,255,255,0.72)"
              overflow="visible"
            >
              {eyebrow}
            </Text>
            <Text
              fontFamily="'Public Sans', sans-serif"
              fontSize={compact ? "1rem" : "1.1rem"}
              fontWeight="600"
              lineHeight="1.35"
              color="white"
              overflow="visible"
              whiteSpace="nowrap"
            >
              {name}
            </Text>
          </Box>
        </Flex>
      </Link>
    ))}
  </Flex>
);
